import api from "../../../api/api";
export const getLocations = data =>
  api.get(
    `term/locations/${data.company_alias}?search=${data.pincode}&sum_assured=${data.sumassured}`,
  );
